import { render, staticRenderFns } from "./StudyInstitutesOverview.vue?vue&type=template&id=100c8600&scoped=true"
import script from "./StudyInstitutesOverview.vue?vue&type=script&lang=ts"
export * from "./StudyInstitutesOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100c8600",
  null
  
)

export default component.exports